import { Action, createReducer, on } from '@ngrx/store';

import * as fromActions from './actions';
import * as fromState from './state';

export const reducer = createReducer(
  fromState.initialState,
  on(fromActions.sendByEmailRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(fromActions.sendByEmailSuccess, (state) => ({
    ...state,
    isLoading: false,
    error: null,
  })),
  on(fromActions.sendByEmailFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),
  on(fromActions.resetState, () => fromState.initialState),
);

export function scaStoreReducer(
  state: fromState.State | undefined,
  action: Action,
) {
  return reducer(state, action);
}
